import React from "react";
import {Modal, ModalBody, ModalHeader} from "../../modal/Modal";

import GLOBAL from "../../../global";
import crossBtn from "../../../assets/img/utils/cross.svg";
import ChiefComplaint from "./ChiefComplaint";
import CONSTANT from "../../../constants/Constant";
import ChatRequestDetail from "../../../models/ChatRequestDetail";
import {useState} from "react";
import {deepClone} from "../../../utils/Utils";

const ChiefComplaintWithBodyPart = (props) => {
    const { isOpen, chat, onSubmit, onClose, ccQuestion, onChange, updateAnswer } = props;
    const [ccCount, setCcCount] = useState(0);

    const handleNoCCFlow = () => {
        const responses = chat?.responses || ccQuestion?.responses || [];
        let noResponse = responses.find(r => r.referenceId === CONSTANT.REFERENCE_RESPONSE.NO);
        if (!noResponse) {
             noResponse = responses.find(r => r.name?.toLowerCase().includes("no"));
        }

        if (noResponse) {
            const chatToUse = chat || ccQuestion;
            if (!chatToUse) return false;

            const updatedChat = deepClone(chatToUse);
            if (updatedChat) {
                updatedChat.answers = [{ ...new ChatRequestDetail(noResponse) }];
                onSubmit && onSubmit(updatedChat);
                return true;
            }
        }
        return false;
    }

    const handleClose = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        handleSubmit(e);
    }

    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (ccCount === 0) {
            handleNoCCFlow();
            return;
        }
        onSubmit && onSubmit(chat);
    }

    return (
        <Modal isOpen={isOpen}
               toggle={handleClose}
               backdrop={'static'}
               className="modal-xl h-100 kt-m0"
               modalClassName="mmh-movement-modal cc-with-body-part">
            {/*<ModalHeader>*/}
            {/*<div className="modal-header align-items-center">*/}
            <div className={"displayFlex justify-content-between w-100"}>
                <h2 className="padding-12px" style={{fontSize: "1.3rem"}}>CHIEF COMPLAINTS &nbsp;&nbsp;</h2>
                <img className="padding-12px cursor-pointer" src={crossBtn} onClick={handleClose} alt="close" />
            </div>
            {/*</div>*/}
            {/*</ModalHeader>*/}
            <ModalBody className="d-flex justify-content-center align-items-center">
                <div className="h-80vh cc-container">
                    <ChiefComplaint
                        testId={(GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['TestId']) || ''}
                        onSubmit={handleSubmit}
                        ccQuestion={ccQuestion}
                        onChange={onChange}
                        onCCCountChange={setCcCount}
                        updateAnswer={updateAnswer}
                    />
                </div>

            </ModalBody>
        </Modal>
    )
}

export default ChiefComplaintWithBodyPart;
